'use client';
import { getLocaleInfo } from '@/utils/helpers';
import useSWR from 'swr';
import { StartingKit } from './useStartingKit';
import useLocale from './useLocale';

export interface PaymentOptions {
  tagline: string;
  payment_options: PaymentOption[];
  title: string;
  cta_text: string;
  next_page: string;
}

export interface PaymentOption {
  shopify_variant_id: string;
  uuid: string;
  bundle_title: string;
  description: string;
  price: number;
  badge_title: string;
  savings: number;
  amount: number;
  amount_type: string;
  size: number;
  kits: PaymentOptionKit[];
  is_default: string;
  tagline?: string;
}

export interface PaymentOptionKit {
  name: string;
  anchor: string;
  age_band: string;
  image_uri: string;
  discounted_price: number;
  price: number;
  scheduled_date: null;
}

export const usePaymentOptions = (
  language: string,
  startingKit?: StartingKit,
) => {
  const locale = useLocale();
  const localeInfo = getLocaleInfo(locale);

  const searchParams = new URLSearchParams({
    selected_language: language,
    language: localeInfo.language,
    currency_code: localeInfo.currencyCode.toLowerCase(),
  });

  const hasFullPaylod =
    startingKit &&
    searchParams.has('selected_language') &&
    searchParams.has('language') &&
    searchParams.has('currency_code');

  searchParams.sort();

  return useSWR<PaymentOptions>(
    hasFullPaylod
      ? `/api/v1/orchestration_subflow/payment_options/${startingKit.anchor}?${searchParams}`
      : null,
  );
};
